export const TOAST_LIST_ID = 'toast-message-list';

export interface ToastMessageListProps {
  messages: string[];
  id?: number | string;
}

export const ToastMessageList = ({ messages, id = TOAST_LIST_ID }: ToastMessageListProps) => (
  <div data-test={TOAST_LIST_ID}>
    {messages.map((message: string, i) => (
      <p key={`${id.toString(2)}-${message}`} data-test={`${id}-${i}`}>
        {message}
      </p>
    ))}
  </div>
);

export default ToastMessageList;
